import { motion } from "framer-motion";
import { Sparkles, Droplets, Hand, Heart, Gem, Scissors } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    id: "lazer-epilasyon",
    title: "Lazer Epilasyon",
    seoTitle: "Bursa Lazer Epilasyon",
    description: "Son teknoloji cihazlarla acısız ve kalıcı lazer epilasyon çözümleri. Pürüzsüz bir cilde kavuşun.",
    icon: Sparkles,
    image: "https://images.unsplash.com/photo-1700760933941-3a06a28fbf47?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  },
  {
    id: "cilt-bakimi",
    title: "Cilt Bakımı",
    seoTitle: "Bursa Profesyonel Cilt Bakımı",
    description: "Profesyonel cilt bakım protokolleri ile cildinize yenileme ve parlaklık kazandırın.",
    icon: Droplets,
    image: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  },
  {
    id: "kafa-masaji",
    title: "Kafa Masajı",
    seoTitle: "Rahatlatıcı Kafa Masajı Bursa",
    description: "Rahatlatıcı ve stres azaltıcı kafa masajı deneyimi ile kendinizi yenileyin.",
    icon: Hand,
    image: "https://images.unsplash.com/photo-1706795034830-de41aee06afa?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  },
  {
    id: "masaj-hizmetleri",
    title: "Masaj Hizmetleri",
    seoTitle: "Bursa Spa Masaj",
    description: "Spa kalitesinde rahatlatıcı terapiler ile bedeninizi ve zihninizi dinlendirin.",
    icon: Heart,
    image: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  },
  {
    id: "protez-tirnak",
    title: "Protez Tırnak",
    seoTitle: "Bursa Protez Tırnak",
    description: "Estetik ve uzun ömürlü protez tırnak tasarımları ile elleriniz her zaman şık görünsün.",
    icon: Gem,
    image: "https://images.unsplash.com/photo-1648844421753-351afd50486a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  },
  {
    id: "manikur-pedikur",
    title: "Manikür & Pedikür",
    seoTitle: "Bursa Manikür Pedikür",
    description: "Hijyenik ortamda profesyonel manikür ve pedikür bakımı ile kendinize özen gösterin.",
    icon: Scissors,
    image: "https://images.pexels.com/photos/18227812/pexels-photo-18227812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1, ease: "easeOut" },
  }),
};

export default function ServicesSection() {
  return (
    <section
      id="hizmetler"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16 md:mb-20"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-4">
            Hizmetlerimiz
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-black">
            Profesyonel Bakım Hizmetleri
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <motion.article
              key={service.id}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={cardVariants}
              data-testid={`service-card-${service.id}`}
              className="relative overflow-hidden group bg-white border border-[#EBEBEB] hover:shadow-[0_20px_40px_rgba(0,0,0,0.05)] transition-all duration-500"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.seoTitle}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center gold-bg">
                    <service.icon size={18} className="text-white" />
                  </div>
                  <h3 className="text-lg font-bold tracking-tight text-black">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm leading-relaxed text-black/70 mb-6">
                  {service.description}
                </p>
                <Link
                  to={`/hizmetler/${service.id}`}
                  data-testid={`service-cta-${service.id}`}
                  className="inline-flex items-center text-xs font-semibold uppercase tracking-widest text-black hover:text-[#B76E79] transition-colors duration-300 group/link"
                >
                  Detaylı İncele
                  <span className="ml-2 w-6 h-[1px] bg-current transition-all duration-300 group-hover/link:w-10" />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
